// extracted by mini-css-extract-plugin
export var activityContainer = "_ln-0";
export var typingIndicatorContainer = "_ln-1";
export var typingIndicatorDot = "_ln-2";
export var wave = "_ln-3";